import $ from 'jquery'
import Screen from './screen'

export default class kvPremior {

  constructor() {
    this.screen = new Screen();
    window.kvPremior = {
      currentWidth: 0,
      activeFlg: false
    }
  }

  init() {
    if (!document.getElementById('mainimgPremior')) {
      return;
    }
    this.setScreenHeightKV();
    window.addEventListener('resize', this.setScreenHeightKV, false);
    return;
  }

  setScreenHeightKV() {
    if (window.kvPremior.currentWidth === window.innerWidth) return;
    if (window.kvPremior.activeFlg) return;
    window.kvPremior.activeFlg = true;
    var vh = window.innerHeight;
    window.kvPremior.currentWidth = window.innerWidth;
    document.getElementById('mainimgPremior').style.height = vh + 'px';
    window.kvPremior.activeFlg = false;
    return window.innerWidth;
  }

}
